export const HEADER_BACKGROUND_COLOUR = '#F8FAFC';

export const TABLE_HEADER_STYLE = 'padding:8px;text-align:left;';
export const TABLE_CELL_STYLE = `${TABLE_HEADER_STYLE}vertical-align:top;`;

export const BORDER_COLOUR = '#EEF1F7';
export const TABLE_STYLE = 'border:1px solid #E6E9F2;border-radius:4px;';

export const addBorderAttributes = ({
	defaultBorderColor = BORDER_COLOUR,
	defaultStyle,
	defaultBackgroundColor,
	defaultBorders = {
		top: false,
		bottom: true,
		left: false,
		right: false,
	},
	defaultPadding,
	defaultMargin,
	defaultBorderRadius,
} = {}) => ({
	backgroundColor: {
		default: defaultBackgroundColor,
		parseHTML: (el) => el.style.backgroundColor ?? el.style.background ?? null,
	},
	borderColor: {
		default: defaultBorderColor,
		parseHTML: (el) => el.style.borderColor ?? defaultBorderColor,
	},

	borderStyle: {
		default: 'solid',
		parseHTML: (el) => el.style.borderStyle ?? 'solid',
	},

	borderWidth: {
		default: '1px',
		parseHTML: (el) => el.style.borderWidth ?? '1px',
	},

	borderTop: {
		default: defaultBorders.top ?? false,
		parseHTML: (el) =>
			el.style.borderTop && el.style.borderTop !== ''
				? Boolean(el.style.borderTop)
				: defaultBorders.top || false,
	},

	borderBottom: {
		default: defaultBorders.bottom ?? true,
		parseHTML: (el) =>
			el.style.borderBottom && el.style.borderBottom !== ''
				? Boolean(el.style.borderBottom)
				: defaultBorders.bottom || false,
	},

	borderLeft: {
		default: defaultBorders.left ?? false,
		parseHTML: (el) =>
			el.style.borderLeft && el.style.borderLeft !== ''
				? Boolean(el.style.borderLeft)
				: defaultBorders.left || false,
	},

	borderRight: {
		default: defaultBorders.right ?? false,
		parseHTML: (el) =>
			el.style.borderRight && el.style.borderRight !== ''
				? Boolean(el.style.borderRight)
				: defaultBorders.right || false,
	},

	padding: {
		default: defaultPadding,
		parseHTML: (el) => el.style.padding || defaultPadding,
	},
	margin: {
		default: defaultMargin,
		parseHTML: (el) => el.style.margin || defaultMargin,
	},
	borderRadius: {
		default: defaultBorderRadius,
		parseHTML: (el) => el.style.borderRadius || defaultBorderRadius,
	},
	baseStyle: {
		default: defaultStyle ?? '',
		parseHTML: () => defaultStyle ?? '',
	},
});

export const resolveBorder = (
	value,
	{ style = 'solid', width = '1px', colour = BORDER_COLOUR },
) => {
	if (value === false || value === null) return '';
	if (value === true) return `${width ?? '1px'} ${style ?? 'solid'} ${colour}`;
	return value;
};

const attributesToRemove = [
	'border',
	'border-top',
	'border-bottom',
	'border-left',
	'border-right',
	'border-color',
	'border-style',
	'border-width',
	'border-radius',
	'background-colour',
	'background',
	'padding',
	'margin',
];

export const buildTableStyle = (attrs, baseStyle) => {
	const {
		style,
		backgroundColor,
		borderColor,
		borderStyle,
		borderWidth,
		borderTop,
		borderBottom,
		borderLeft,
		borderRight,
		borderRadius,
		padding,
		margin,
	} = attrs;

	const props = { colour: borderColor, style: borderStyle, width: borderWidth };

	const splitStyle = (style ?? '')
		.split(';')
		.filter((v) => v.includes(':'))
		.map((v) => v?.trim());

	const splitBaseStyle = (baseStyle ?? '').split(';').filter((v) => v.includes(':'));
	const baseStyleAttrs = splitBaseStyle.map((v) => v.split(':')[0]);

	const cleanSplit = splitStyle.filter(
		(v) =>
			![...attributesToRemove, ...baseStyleAttrs].some((param) =>
				v.split(':')[0].includes(param),
			),
	);

	const styleArray = [
		...cleanSplit,
		...(backgroundColor ? [`background-color:${backgroundColor}`] : []),
		...(margin ? [`margin:${margin}`] : []),
		...(padding ? [`padding:${padding}`] : []),
		...(borderRadius ? [`border-radius:${borderRadius}`] : []),
		...(resolveBorder(borderTop, props)
			? [`border-top:${resolveBorder(borderTop, props)}`]
			: []),
		...(resolveBorder(borderBottom, props)
			? [`border-bottom:${resolveBorder(borderBottom, props)}`]
			: ['']),
		...(resolveBorder(borderLeft, props)
			? [`border-left:${resolveBorder(borderLeft, props)}`]
			: []),
		...(resolveBorder(borderRight, props)
			? [`border-right:${resolveBorder(borderRight, props)}`]
			: []),
		...splitBaseStyle,
	].filter(Boolean);

	const newStyle = styleArray.join(';');
	return !newStyle || newStyle.endsWith(';') ? newStyle : `${newStyle};`;
};
